import React from "react";
import ServicesContentContainer from "../components/ServicesContentContainer";
import MainSection from "../components/MainSection";

const Sg = () => {
  const contentData = [
    {
      id: 1,
      title: "Understanding Your Goals",
      description:
        "Our guidance process begins with a thorough conversation where we aim to understand your educational and career goals, your interests, and strengths. This helps us to personalize our advice and recommendations to your specific needs.",
    },
    {
      id: 2,
      title: "Identifying Suitable Scholarships",
      description:
        "Once we understand your goals, we assist you in identifying scholarships that align with your career objectives. We provide insights into various scholarships, their eligibility requirements, and application processes.",
    },
    {
      id: 3,
      title: "Assisting with Application Documents",
      description:
        "We help you prepare all necessary documents for your scholarship application. This includes help with writing impactful personal statements, resumes, and reference letters that stand out.",
    },
    {
      id: 4,
      title: "Application Submission",
      description:
        "We ensure that your application documents are submitted on time and in the correct format. Our team stays updated on all deadlines to provide you with timely reminders.",
    },
    {
      id: 5,
      title: "Interview Preparation",
      description:
        "If your scholarship application includes an interview process, we provide mock interviews and constructive feedback to ensure you are well prepared.",
    },
    {
      id: 6,
      title: "Managing Scholarship Awards",
      description:
        "We guide you on how to manage scholarship awards and inform you about the terms and conditions associated with the scholarship.",
    },
  ];
  const conclusion =
    "Throughout this journey, we provide you with support, advice, and the expertise you need to secure the scholarship that will help make your educational aspirations a reality.";

  return (
    <>
      <MainSection bannerTxt="SCHOLARSHIP GUIDANCE" color="gray" />
      <ServicesContentContainer
        contentData={contentData}
        conclusion={conclusion}
        title={"Scholarship Guidance"}
        includeTxt={"Processes"}
      />
    </>
  );
};

export default Sg;
